var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { IntlProvider } from 'react-intl';
import useColors from '../../hooks/useColors';
import useContestsData from '../../hooks/useContestsData';
import languages, { DEFAULT_LANGUAGE } from '../../languages';
import { flattenMessages } from '../../utils/flattenMessages';
import { MeasurementUnits } from '../../utils/formatMeasurement';
import { Header, LoadingSpinner, SingleContest } from '../partials';
import NoResultsMessage from '../partials/NoResultsMessage';
var CONTESTS_ID = 'game-contests-container';
export default function GameContests(_a) {
    var endpoint = _a.endpoint, _b = _a.theme, theme = _b === void 0 ? 'light' : _b, className = _a.className, apiToken = _a.apiToken, language = _a.language, _c = _a.measurementUnit, measurementUnit = _c === void 0 ? MeasurementUnits.METRIC : _c, refreshInterval = _a.refreshInterval, colors = _a.colors, _d = _a.units, units = _d === void 0 ? 'metric' : _d, timezone = _a.timezone;
    var _e = useContestsData(endpoint, apiToken, refreshInterval), data = _e.data, loading = _e.loading;
    useColors(CONTESTS_ID, colors === null || colors === void 0 ? void 0 : colors.primary, colors === null || colors === void 0 ? void 0 : colors.secondary);
    var getContainerClasses = function () {
        var baseClass = loading ? "".concat(CONTESTS_ID, " loading") : CONTESTS_ID;
        return className ? "".concat(baseClass, " ").concat(className) : baseClass;
    };
    var getContestsForRound = function (round) {
        var _a;
        var contests = ((_a = data === null || data === void 0 ? void 0 : data.rounds) === null || _a === void 0 ? void 0 : _a[round].contests) || [];
        return contests.map(function (contest) {
            var updatedEntries = contest.entries.map(function (entry) {
                //TODO: Remove this hack when https://golfgamebook.atlassian.net/browse/CORE-1318 is done
                if (entry.scoreString === '0') {
                    return __assign(__assign({}, entry), { score: 0.0 });
                }
                return entry;
            });
            return __assign(__assign({}, contest), { entries: updatedEntries });
        });
    };
    var getRoundNumbers = function () {
        var roundCount = (data === null || data === void 0 ? void 0 : data.rounds.length) || 0;
        return Array.from({ length: roundCount }, function (_, i) { return i; });
    };
    var getHeaderData = function () {
        if (data && data.rounds.length > 0) {
            var firstRound = data.rounds[0];
            return {
                gameName: data.gameName,
                clubName: firstRound.clubName,
                courseName: firstRound.courseName,
                par: firstRound.coursePar,
                date: firstRound === null || firstRound === void 0 ? void 0 : firstRound.startTime,
                units: units,
                timezone: timezone
            };
        }
        return;
    };
    var getLanguage = function () {
        return language || DEFAULT_LANGUAGE;
    };
    var renderContestsOrShowMessage = function () {
        if (loading) {
            return React.createElement(LoadingSpinner, null);
        }
        var noResults = data === null || (data === null || data === void 0 ? void 0 : data.rounds.length) === 0;
        if (noResults) {
            return React.createElement(NoResultsMessage, { id: "leaderboard.contestsNotPublished" });
        }
        return (React.createElement(React.Fragment, null, getRoundNumbers().map(function (round) {
            return getContestsForRound(round).map(function (contest, i) { return (React.createElement(SingleContest, { key: i, contest: contest, measurementUnit: measurementUnit })); });
        })));
    };
    return (React.createElement(IntlProvider, { locale: getLanguage(), messages: flattenMessages(languages[getLanguage()]) },
        React.createElement("div", { "data-theme": theme, className: getContainerClasses(), id: CONTESTS_ID },
            React.createElement(Header, { data: getHeaderData() }),
            renderContestsOrShowMessage())));
}
